import { useQuery } from '@tanstack/react-query';
import { useOrganization } from '@/hooks/useOrganization';
import { listEventosCliente } from '@/services/eventos.service';

export function useEventos(clienteId: string | undefined) {
  const { organizationId } = useOrganization();

  return useQuery({
    queryKey: ['eventos', organizationId, clienteId],
    queryFn: () => (clienteId ? listEventosCliente(clienteId) : Promise.resolve([])),
    enabled: !!clienteId,
  });
}
